import * as React from "react";

interface BackgroundIndexProps {
  index: number; // числовая переменная
}

export const NftIndexCounter: React.FC<BackgroundIndexProps> = ({ index }) => {
  return (
    <div className="absolute top-0 left-0 bg-[#000000] opacity-50 px-[10px] text-[12px] font-silkscreen text-white">
      #{index}
    </div>
  );
};
